export default {
  title: 'Rename',
  form: {
    label: {
      title: 'Title *',
      description: 'Description (optional)',
    },
    rule: {
      emptyTitle: 'The title is required',
      titleMaxCharacters: 'The title must be up to %{titleMaxCharacters} characters',
      descriptionMaxCharacters: 'The description must be up to %{descriptionMaxCharacters} characters',
    },
  },
  label: {
    button: {
      confirmButton: 'Save',
      cancelButton: 'Cancel',
    },
  },
};
